<template>
  <g>
    <circle
      cx="10"
      cy="10"
      r="8.5"
      stroke="currentColor"
      stroke-width="1.5"
      fill="none"
    />
    <path
      d="M7 7L13 13M13 7L7 13"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </g>
</template>

<script>
export default {
  name: 'IconDelete',
}
</script>
